import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import Button from '../components/ui/Button';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-blue-500 mb-4">404</h1>
        <h2 className="text-3xl font-semibold text-white mb-4">Страница не найдена</h2>
        <p className="text-gray-400 mb-8">
          К сожалению, запрашиваемая страница не существует
        </p>
        <Link to="/">
          <Button className="inline-flex items-center">
            <Home className="w-5 h-5 mr-2" />
            Вернуться на главную
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
